import assetPath from '../utils/assetPath';

const copy = {
  en: {
    heroTitle: 'Precision. Discipline. SΛLTY.',
    saltyLine: "Can't drown. It's SΛLTY.",
    heroBody: 'We are a competitive airsoft squad focused on disciplined play, clear comms, and sharp execution.',
    ctas: {
      primary: 'Meet the Team',
      secondary: 'Instagram',
    },
    teamIntro: {
      title: 'Who We Are',
      body:
        'SΛLTY trains with structure and intent, balancing field experience, technical skills, and steady teamwork.',
    },
    partners: {
      title: 'Partner Network',
      body: 'Shops and fields that support our training, events, and equipment needs.',
      shops: [
        {
          name: 'F16 ATOM',
          desc: 'Outdoor CQB field that hosts night sessions and partner events.',
          url: 'https://www.facebook.com/p/F16-ATOM-922-100090054549139/',
          logo: assetPath('/assets/partner-f16-atom.jpg'),
        },
        {
          name: 'OPS Store',
          desc: 'Specialized airsoft shop for outfitting kits and handling last-minute fixes.',
          url: 'https://www.ops-store.fr/',
          logo: assetPath('/assets/logo-ops-store.jpg'),
        },
      ],
    },
    members: {
      preheading: 'SΛLTY Roster',
      title: 'Operators & Roles',
      body: 'Each member covers a role so the squad can shift from recon to direct action with control.',
    },
    videos: {
      preheading: 'Latest Videos',
      title: 'Member Videos',
      body: 'Fresh footage from members with a YouTube channel. Tap a card to see the most recent video.',
      loading: 'Loading latest videos...',
      unavailable: 'Latest video unavailable right now.',
      previewUnavailable: 'Preview unavailable.',
      play: 'Play video',
      cta: 'Watch on YouTube',
    },
  },
  fr: {
    heroTitle: 'Précision. Discipline. SΛLTY.',
    saltyLine: "Can't drown. It's SΛLTY.",
    heroBody:
      'Nous sommes une équipe d’airsoft axée sur la discipline, la communication claire et l’exécution.',
    ctas: {
      primary: "Rencontrer l'équipe",
      secondary: 'Instagram',
    },
    teamIntro: {
      title: 'Qui nous sommes',
      body:
        'SΛLTY s’entraîne de façon structurée, avec un équilibre entre expérience terrain, technique et cohésion.',
    },
    partners: {
      title: 'Partenaires',
      body: 'Boutiques et terrains qui soutiennent nos entraînements, événements et besoins en équipement.',
      shops: [
        {
          name: 'F16 ATOM',
          desc: 'Terrain CQB extérieur qui accueille des sessions de nuit et des événements partenaires.',
          url: 'https://www.facebook.com/p/F16-ATOM-922-100090054549139/',
          logo: assetPath('/assets/partner-f16-atom.jpg'),
        },
        {
          name: 'OPS Store',
          desc: 'Boutique spécialisée qui équipe l’équipe et gère les ajustements de dernière minute.',
          url: 'https://www.ops-store.fr/',
          logo: assetPath('/assets/logo-ops-store.jpg'),
        },
      ],
    },
    members: {
      preheading: 'Roster SΛLTY',
      title: 'Opérateurs & Rôles',
      body:
        'Chaque membre occupe un rôle pour permettre une transition maîtrisée entre reconnaissance et assaut.',
    },
    videos: {
      preheading: 'Dernières vidéos',
      title: 'Vidéos des membres',
      body: 'Les dernières vidéos des membres ayant une chaîne YouTube. Cliquez pour voir la vidéo la plus récente.',
      loading: 'Chargement des dernières vidéos...',
      unavailable: 'Dernière vidéo indisponible pour le moment.',
      previewUnavailable: 'Aperçu indisponible.',
      play: 'Lancer la vidéo',
      cta: 'Voir sur YouTube',
    },
  },
};

export default copy;
